// import React from 'react';
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Pdf } from '../function/pdf'
import { saveAs } from 'file-saver'
import * as Common from '../../common'
import {
  Authority,
  isHiddenProject,
  isHiddenPurChase,
  isHiddenProperty,
} from '../../common'

//画像読み込み
import LogoBlue from '../../assets/images/logo_blue.png'
import IcoHomeWhite from '../../assets/images/ico_home_white.svg'
import IcoProjectWhite from '../../assets/images/ico_project_white.svg'
import IcoPurchaseWhite from '../../assets/images/ico_purchase_white.svg'
import IcoPropertyWhite from '../../assets/images/ico_property_white.svg'

//コンポーネント読み込み
import Result from '../parts/result'
import PdfDocument from '../parts/PdfDocument'
import axios from 'axios'
import ForcedLogout from '../function/ForcedLogout'

function List(props: any) {
  /**
   * モーダルを開いているかどうか
   */
  const [isModalOpen, setStateModal] = useState<boolean>(false)

  /**
   * 帳票を開くまでのローディング画面を表示しているかどうか
   */
  const [isFormLoadingShow, setIsFormLoadingShow] = 
    useState<boolean>(false)

  /**
   * Resultで選択しているID
   */
  const [selectedItemInResult, setSelectedItemInResult] = useState(null)

  /**
   * 帳票の画像アドレス
   */
  const [formImgUrl, setFormImgUrl] = useState<string>('')

  /**
   * 帳票のPDFアドレス
   */
  const [formPdfUrl, setFormPdfUrl] = useState<string>('')

  /**
   * 帳票パターン
   */
  const [formPattern, setFormPattern] = useState<number>(1)

  /**
   * 帳票に出力するデータ
   */
  const [formInfo, setFormInfo] = useState<any>(null)

  /**
   * me
   */
  const [meInfo, setMeInfo] = useState<any>(null)

  /**
   * system Setting
   */
  const [systemSetting, setSystemSetting] = useState<any>(null)

  /**
   * loading（アクセス権限判定までのローディング）
   */
  const [isLoading, setIsLoading] = useState<boolean>(true)

  /**
   * isDisplay（アクセス権限判定）
   */
  const [isHidden, setHiddenDisplay] = useState<boolean>(false)

  /**
   * 権限のオブジェクトを作る
   */
  const [authoritySetting, setAuthoritySetting] =
    useState<Authority | null>(null)

  /**
   * init
   */
  useEffect(() => {
    axios
      .get(`${Common.API_DOMAIN()}/api/api/v1/auth/me`, {
        headers: {
          Authorization: `Bearer ${props.token}`,
        },
      })
      .then((response) => {
        setMeInfo(response.data)

        axios
          .get(`${Common.API_DOMAIN()}/api/api/v1/m_system_settings`, {
            headers: {
              Authorization: `Bearer ${props.token}`,
            },
          })
          .then((response) => {

            if (response.data) {
              setSystemSetting(response.data[0])
            }
          })
          .catch((error) => {
            console.error(error)
          })
      })
      .catch((error) => {
        console.error({error})
        //エラーコードが401のとき（＝トークン有効期限切れのとき）
        if({error}.error.response.status==='401'){
          //強制ログアウト
          ForcedLogout(history, props.token)
        }
      })
  }, [])

  /**
   * 権限に関するデータを作る
   */
  useEffect(() => {
    if (meInfo && systemSetting) {
      setAuthoritySetting({
        project_management_permission: meInfo.project_management_permission,
        order_management_permission: meInfo.order_management_permission,
        purchase_management_permission: meInfo.purchase_management_permission,
        plan_id: meInfo.m_plan.id,
        property_management_flag: systemSetting.property_management_flag,
      })

      // 画面を表示するかどうかの判定
      switch (props.pageType) {
        case 'project':
          // 制約がかかるパターン
          // notDisplayPageCondition.projectで設定されてる値を含んでいれば非表示
          const hiddenProject = isHiddenProject(
            meInfo.project_management_permission,
          )

          setHiddenDisplay(hiddenProject)
          setIsLoading(false)
          return
        case 'purchase':
          // 制約かかるパターン
          // notDisplayPageCondition.purchaseで設定されてる値を含んでいれば非表示
          const hiddenPurchase = isHiddenPurChase(
            meInfo.order_management_permission,
            meInfo.plan_id,
          )
          setHiddenDisplay(hiddenPurchase)
          setIsLoading(false)
          return
        case 'property':
          // 制約かかるパターン
          // notDisplayPageCondition.propertyで設定されてる値を含んでいれば非表示
          const hiddenProperty = isHiddenProperty(
            systemSetting.property_management_flag,
          )
          setHiddenDisplay(hiddenProperty)
          setIsLoading(false)
          return
        default:
      }
    }
  }, [meInfo, systemSetting])

  /**
   * 参照ボタンをクリックしたとき
   */
  const onClickView = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault()

    //Result内で選択されている項目がある場合
    if (props.selectedItemInResult !== null) {

      //ローディング画面を表示
      setIsFormLoadingShow(true)

      //API-002で、帳票パターンを取得する
      axios
        .get(`${Common.API_DOMAIN()}/api/api/v1/auth/me`, {
          headers: {
            Authorization: `Bearer ${props.token}`,
          },
        })
        .then((response) => {

          //帳票パターンを取得

          /**
           * 帳票パターン番号
           */
          const formPatternNum =
            response.data.m_option_setting.m_slip_item_patterns_id

          //番号をformPatternに格納
          //2段階にしなければformPatternが更新されないため、このような手段をとる
          setFormPattern(formPatternNum)

          //帳票に載せる情報を取得するAPIのURL
          const formApiUrl = `${Common.API_DOMAIN()}/api/api/v1/t_${props.pageType}_bases/detail/${props.selectedItemInResult.id}`

          //API212-1で、帳票に載せる情報を取得
          axios
            .get(formApiUrl, {
              headers: {
                Authorization: `Bearer ${props.token}`,
              },
            })
            .then((response) => {

              //帳票に出力する値を取得
              setFormInfo(response.data)

              //帳票のdataURIを取得
              Pdf(Number(formPatternNum)).then((path: any) => {
                //IMAGEのdataURIをステート'formImgUrl'に設定
                setFormImgUrl(path.imgPath)

                //PDFのdataURIをステート'formPdfUrl'に設定
                setFormPdfUrl(path.pdfPath)

                //モーダルを表示
                setStateModal(true)

                //ローディング画面を非表示
                setIsFormLoadingShow(false)
              })
            })
            .catch((error) => {
              console.error(error)
            })
        })
        .catch((error) => {
          console.error({error})
          //エラーコードが401のとき（＝トークン有効期限切れのとき）
          if({error}.error.response.status==='401'){
            //強制ログアウト
            ForcedLogout(history, props.token)
          }
        })
    } else {
      alert('明細を選択してください')
    }
  }

  /**
   * 物件一覧画面で「Googleマップ」ボタンを押したとき
   */
  const onClickGoogleMap = () => {
    // 物件が選択されていれば
    if (props.selectedItemInResult) {
      //物件に住所があれば
      if([null,''].indexOf(props.selectedItemInResult.search_address)===-1){
        // Google Mapを開く
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${props.selectedItemInResult.search_address}`,
        )
      } else {
        //なければアラート
        alert('住所が入力されていません')
      }
    } else {
      //選択されていなければアラートを出す
      alert('明細を選択してください')
    }
  }

  /**
   * 物件一覧画面で「案件一覧をみる」ボタンを押したとき
   */
  const onClickProjectList = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.preventDefault()
    // 物件が選択されていれば
    if (props.selectedItemInResult !== null) {
      // 物件情報をクエリパラメータにつけて案件一覧へと遷移
      history.push(`/project?property_name=${props.selectedItemInResult.property_name}`)
    } else {
      //選択されていなければアラートを出す
      alert('明細を選択してください')
    }
  }

  /**
   * プレビューボタンを押したとき
   */
  const onClickPreview = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation()

    /**
     * 新しいウインドウ
     */
    let pdfWindow = window.open('')

    //pdfWindowをifに通す（TypeScriptのエラー対策）
    if (pdfWindow) {
      //新しいウインドウに画像を開く
      pdfWindow.document.write(`<img src="${formImgUrl}" alt="" />`)

      //画像を保存できなくする
      pdfWindow.document.head.insertAdjacentHTML(
        'beforeend',
        '<style>img{pointer-events:none;max-width:100%;}</style>',
      )
    }
  }

  /**
   * ダウンロードボタンを押したとき
   */
  const onClickDownload = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation()

    //fileSaverでダウンロード
    saveAs(formPdfUrl, `${props.selectedItemInResult.project_code}.pdf`)
  }

  const history = useHistory()

  /**
   * ログアウト
   */
  const logOut = () => {
    //cookieを破棄
    document.cookie = 'cookieToken=;max-age=' + 0
    history.push('/login')
  }

  // PDFダウンロードをアクティブにするかの判定
  // 非表示（PDF参照ボタン非表示）のパターンは保存不可の条件に含めなくても
  // そもそも表示されないので、仕様書の保存不可のパターンのみを考える
  // 保存不可パターン抽出
  const isDownloadButtonDisable = () => {
    if (!authoritySetting || !formInfo) return false

    switch (props.pageType) {
      case 'project':
        // 案件ページ
        // RW以外は保存不可
        return authoritySetting.project_management_permission === 2
          ? true
          : false
      case 'purchase':
        // 購買ページ
        // 仕様書ではプレミアムプランの時だが、それ以外のプランではそもそも非表示なのでプランの判定は無視する
        // 発注管理がRO。ただし仕入れ管理がRWかつステータスが仕入れの場合を除く（仕様書表のD列）
        // または、発注管理がRWでステータスが仕入れの場合（仕様書表のC列12行目）
        return (authoritySetting.order_management_permission === 2 &&
          !(
            authoritySetting.purchase_management_permission === 1 &&
            formInfo.status === 4
          )) ||
          (authoritySetting.order_management_permission === 1 &&
            authoritySetting.purchase_management_permission === 2 &&
            formInfo.status === 4)
          ? true
          : false
      default:
        return false
    }
  }

  return (
    <>
      <div className="splash splash--form" data-is-show={isFormLoadingShow}>
        <div className="splash__inner">
          <div className="loading-animation splash__loading-animation">
            <div className="loading-animation__inner">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div
        className={props.pageType + ' content'}
        data-is-modal-open={isModalOpen}
      >
        <div className={props.pageType + '__inner content__inner'}>
          {(props.pageType === 'project' || props.pageType === 'purchase') && (
            <div
              className="modal project__modal"
              onClick={() => setStateModal(false)}
            >
              <div className="modal__inner">
                <div className="modal__content">
                  <div className="modal__content-inner">
                    <div className="modal__top">
                      <a
                        className="modal__top-btn"
                        id="js-preview"
                        onClick={(e: any) => {
                          onClickPreview(e)
                        }}
                      >
                        PDFプレビュー
                      </a>
                      <a
                        className={`modal__top-btn ${
                          isDownloadButtonDisable() && 'disable'
                        }`}
                        id="js-view-pdf"
                        onClick={(e: any) => {
                          onClickDownload(e)
                        }}
                      >
                        PDFダウンロード
                      </a>
                    </div>
                    <div className="modal__bottom">
                      <a
                        className="modal__bottom-btn"
                        id="js-close-modal"
                        onClick={() => setStateModal(false)}
                      >
                        戻る
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="list-page-ttl">
            <p className="list-page-ttl__logo">
              <img src={LogoBlue} alt="Goolip" />
            </p>
            <h1 className="list-page-ttl__text">{props.pageTypeJa}一覧</h1>
            <a className="list-page-ttl__logout" onClick={logOut}>
              ログアウト
            </a>
          </div>
          {isLoading ? (
            <div className="loading-content">
              <div className="loading-animation splash__loading-animation">
                <div className="loading-animation__inner">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          ) : !isHidden ? (
            <>
              {props.children}
              {props.resultObject && authoritySetting && (
                <Result
                  resultCondition={props.resultCondition}
                  resultObject={props.resultObject}
                  pageTypeJa={props.pageTypeJa}
                  resultItemName={props.resultItemName}
                  pageType={props.pageType}
                  onSubmit={(e: any) => {
                    if(props.pageType==='property'){
                        onClickProjectList(e)
                    }else{
                        onClickView(e)
                    }
                  }}
                  onViewGoogleMap={()=>{
                    onClickGoogleMap()
                  }}
                  onChangeResultCondition={props.onChangeResultCondition}
                  onChangeselectedItemInResult={(value: any) => {
                    props.onChangeselectedItemInResult(value)
                  }}
                  authoritySetting={authoritySetting}
                ></Result>
              )}
            </>
          ) : props.pageType !== 'property' ? (
            <div className="empty-content">アクセス権限がありません</div>
          ) : (
            <div className="empty-content">
              物件管理フラグがオフになっています
            </div>
          )}
        </div>
      </div>

      <footer className="navigation">
        <nav className="navigation__inner">
          <ul className="navigation__list">
            <li className="navigation__item">
              <Link
                to="/project"
                className={`navigation__link ${
                  authoritySetting &&
                  isHiddenProject(
                    authoritySetting.project_management_permission,
                  ) &&
                  'disable'
                }  ${isLoading ? 'isLoading' : ''}`}
              >
                <div className="navigation__link-icon navigation__link-icon--home">
                  <img src={IcoHomeWhite} alt="" />
                </div>
                <div className="navigation__link-text">ホーム</div>
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                to="/project"
                className={`navigation__link ${
                  authoritySetting &&
                  isHiddenProject(
                    authoritySetting.project_management_permission,
                  )
                    ? 'disable'
                    : ''
                } ${isLoading ? 'isLoading' : ''}`}
              >
                <div className="navigation__link-icon navigation__link-icon--project">
                  <img src={IcoProjectWhite} alt="" />
                </div>
                <div className="navigation__link-text">案件一覧</div>
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                to="/purchase"
                className={`navigation__link ${
                  authoritySetting &&
                  isHiddenPurChase(
                    authoritySetting.order_management_permission,
                    authoritySetting.plan_id,
                  )
                    ? 'disable'
                    : ''
                }  ${isLoading ? 'isLoading' : ''}`}
              >
                <div className="navigation__link-icon navigation__link-icon--purchase">
                  <img src={IcoPurchaseWhite} alt="" />
                </div>
                <div className="navigation__link-text">購買一覧</div>
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                to="/property"
                className={`navigation__link ${
                  authoritySetting &&
                  isHiddenProperty(authoritySetting.property_management_flag)
                    ? 'disable'
                    : ''
                }  ${isLoading ? 'isLoading' : ''}`}
              >
                <div className="navigation__link-icon navigation__link-icon--property">
                  <img src={IcoPropertyWhite} alt="" />
                </div>
                <div className="navigation__link-text">物件一覧</div>
              </Link>
            </li>
          </ul>
        </nav>
      </footer>

      <div
        style={{
          zIndex: -10000,
          width: '1200px',
          position: 'absolute',
          left: '-5000px',
          top: '-20000px',
        }}
      >
        <PdfDocument
          pageType={props.pageType}
          token={props.token}
          formPattern={formPattern}
          formInfo={formInfo}
          meInfo={meInfo}
        ></PdfDocument>
      </div>
      <div id="myMm" style={{ height: '1mm' }} />
    </>
  )
}

export default List
